import { useCallback, useRef } from 'react';
import useResizeObserver from 'use-resize-observer';
import { calculateRowHeight, calculateWrapping } from './helpers';

/**
 * A special hook that tries to put all children in one line if there is enough space.
 * If children don't fit the space, it shows only first ones that fit and adds 'more' button.
 * When 'more' button is clicked, the component shows extra popover with all children wrapped
 */
export const useOverflowContainer = (
  onOverflowChange: (value: boolean) => void,
  onRowHeightChange: (value: number) => void,
  onWidthChange: (value: number) => void
) => {
  const ref = useRef<HTMLDivElement>(null);

  const onResize = useCallback(() => {
    onRowHeightChange(calculateRowHeight(ref.current));
    onOverflowChange(calculateWrapping(ref.current));
    onWidthChange(ref.current?.offsetWidth || 0);
  }, [onOverflowChange, onRowHeightChange, onWidthChange]);

  useResizeObserver<HTMLDivElement>({ ref, onResize });

  return ref;
};
